import error_image from '@/assets/image/file.png';
import Image from 'next/image';
import Link from 'next/link';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

interface PropshomePage {
    ishomePage?: boolean | null;
}

export default function ErrorMainPages(props: PropshomePage) {
    const { ishomePage } = props;

    return (
        <>
            <div className="h-[80svh] size-full flex flex-col justify-center items-center">
                <Image
                    alt={`خطا در دریافت اطلاعات`}
                    width={700}
                    height={700}
                    src={error_image.src}
                    className="w-1/4 h-[300px]"
                />
                <Badge color="crimson">ارتباط برقرار نشد !</Badge>
                <div className="flex gap-3">
                    <Button
                        onClick={() =>
                            window.location.replace(window.location.href)
                        }
                    >
                        {' '}
                        {/* Ensure reset is defined before calling */}
                        تلاش مجدد
                    </Button>
                    {ishomePage === true ? null : (
                        <Button asChild>
                            <Link href="/">برگشت به صفحه اصلی</Link>
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
}
